import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const ProtectedRoute = ({ children }) => {
  const { userSession } = useAuth();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, [userSession]);

  if (isLoading) {
    return (
      <div className="tw-flex tw-items-center tw-justify-center tw-h-screen">
        <Loader2 className="tw-animate-spin tw-h-10 tw-w-10 tw-text-[#00B5ED]" />
      </div>
    );
  }

  if (!userSession) {
    return <Navigate to="/signin" replace />;
  }
  // Render the protected component if the user is signed in
  return children;
};

export default ProtectedRoute;
